import { IStyle } from '@fluentui/react';

export interface IGPTeTokenDataStyles {
  root: IStyle;
  gridAreaContainer: IStyle;
  pieChartWrapper: IStyle;
  chartContainer: IStyle;
}

export const gpteTokenDataStylesDefault = (): Partial<IGPTeTokenDataStyles> => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    overflowX: 'hidden',
  },
  gridAreaContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gridRowGap: '4rem',
    gridColumnGap: '1rem',
    marginTop: '1rem',
    width: '100%',
  },
  pieChartWrapper: {
    width: '65%',
    maxWidth: '100%',
    margin: '0 auto',
  },
});
